import { observer } from 'mobx-react-lite'
import { Navigate, useOutletContext } from 'react-router'
import type { TeamsViewModel } from '@/features/iam/teams/TeamsViewModel'
import { links } from '@/utils/link'

/**
 * Shows the first team when the route names none.
 */
export default observer(function WorkspaceTeamsIndexContainer() {
  const team = useOutletContext<TeamsViewModel>().defaultTeam
  return team && <Navigate replace to={links.team(team.slug)} />
})
